import React from "react";

const LOGO = "/revive-logo.png";

export const Logo = ({ className = "h-12 sm:h-14 lg:h-16", withText = false }) => (
  <div className="flex items-center gap-3" data-testid="revive-logo">
    <img src={LOGO} alt="Revive Family Clinic & X-Ray Diagnostics logo" className={`${className} w-auto object-contain`} />
    {withText && (
      <div className="leading-tight">
        <div className="font-extrabold text-[#0F1E36] text-base sm:text-lg tracking-tight">REVIVE</div>
        <div className="text-[10px] sm:text-[11px] font-semibold text-[#1A75BC] -mt-0.5">Family Clinic & X-Ray</div>
      </div>
    )}
  </div>
);

export default Logo;
